/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMakerHeadshotModule_seller = {
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly sellerPreferences: {
        readonly urlLabel: string | null;
    } | null;
    readonly liveStorefrontProfile: {
        readonly photos: ReadonlyArray<{
            readonly type: {
                readonly name: string | null;
            } | null;
            readonly path: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedMakerHeadshotModule_seller";
};
export type PdpSharedMakerHeadshotModule_seller$data = PdpSharedMakerHeadshotModule_seller;
export type PdpSharedMakerHeadshotModule_seller$key = {
    readonly " $data"?: PdpSharedMakerHeadshotModule_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedMakerHeadshotModule_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedMakerHeadshotModule_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerPreferences",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "liveStorefrontProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "photos",
          "storageKey": null,
          "args": null,
          "concreteType": "Photo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "PhotoType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e6111f1f4af52f0b3fb7490f342d0643';
export default node;
